<template>
  <v-form
    ref="form"
    v-model="valid"
    class="create-profile-template-form"
    @submit.prevent="submitForm"
  >
    <div class="d-flex flex-column ga-4">
      <DpplTextField
        v-model="title"
        label="Template Name"
        outlined
        :rules="titleRules"
        :disabled="loading"
        dense
      />
      <v-btn
        color="primary"
        variant="flat"
        rounded="lg"
        type="submit"
        :loading="loading"
        :disabled="!valid || loading"
      >
        Create Template
      </v-btn>
    </div>
  </v-form>
</template>

<script setup>
import { ref } from 'vue';
import { createJobProfileTemplate } from '@/api/jobProfile';
import { useAppSnackbar } from '@/stores/app/snackbar';
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import validation from '@/helpers/validation';

const emit = defineEmits(['created']);

const { addMultilineErrorSnackbar } = useAppSnackbar();

const form = ref(null);
const title = ref('');
const valid = ref(false);
const loading = ref(false);

const titleRules = validation.titleRules();

const submitForm = async () => {
  try {
    const formValidateResult = await form.value?.validate();

    if (formValidateResult?.valid) {
      loading.value = true;

      const response = await createJobProfileTemplate({
        title: title.value?.trim() || undefined,
      });

      emit('created', { template_ulid: response.template_ulid });
    }
  } catch (e) {
    addMultilineErrorSnackbar({
      text: `An error occurred while creating this template.
            Our support team will contact you once the issue has been resolved.
            ${e.message}
          `,
    });

    throw e;
  } finally {
    loading.value = false;
  }
};

const resetForm = () => {
  title.value = '';
  form.value?.resetValidation();
};

defineExpose({
  resetForm,
});
</script>
